import {
	CLOSED_STATUS_COLOR,
	COMPLETE_STATUS_COLOR,
	NO_RESULTS_STATUS_COLOR,
	PENDING_STATUS_COLOR,
	PLANNED_STATUS_COLOR,
} from 'utils/constants';
import { SurveyRoundStatus } from '../models';

export const getStatusColor = (status: SurveyRoundStatus) => {
	switch (status) {
		case SurveyRoundStatus.PENDING:
			return PENDING_STATUS_COLOR;
		case SurveyRoundStatus.COMPLETE:
			return COMPLETE_STATUS_COLOR;
		case SurveyRoundStatus.PARTIAL:
			return PLANNED_STATUS_COLOR;
		case SurveyRoundStatus.ERROR:
			return CLOSED_STATUS_COLOR;
		case SurveyRoundStatus.NO_RESULTS:
			return NO_RESULTS_STATUS_COLOR;
		default:
			return NO_RESULTS_STATUS_COLOR;
	}
};
